const TELEMETRY_VERSION = 1;
const TUTORIAL_VERSION = 2;
const fields = /* @__PURE__ */ new Set([
  "app_version",
  "telemetry_version",
  "tutorial_version",
  "browser",
  "source_context",
  "auth_state",
  "is_internal",
  "page_kind",
  "plan",
  "key",
  "step_id",
  "trigger",
  "choice",
  "method",
  "outcome",
  "error_code",
  "state",
  "reason",
  "is_new_account",
  "attempt_id",
  "recognition_id",
  "request_id",
  "checkout_id",
  "feedback_id",
  "plugin",
  "name",
  "nthCmdToday",
  "quota_exceeded",
  "execution_stage",
  "is_final",
  "duration_ms",
  "term",
  "old_plan",
  "new_plan",
  "payment_status",
  "mode",
  "exercise_id",
  "version",
  "checkedSite",
  "checkedBroken",
  "checkedAccent",
  "checkedUseful",
  "checkedInsufficient",
  "checkedExpensive",
  "checkedOther",
  "url",
  "is_pinned"
]);
function pageKind(url) {
  if (!url) return "unknown";
  try {
    const parsed = new URL(url);
    if (["chrome-extension:", "moz-extension:"].includes(parsed.protocol)) {
      if (/\/tutorial(?:\.html|\/|$)/i.test(parsed.pathname)) return "tutorial";
      if (/\/options(?:\.html|\/|$)/i.test(parsed.pathname)) return "options";
      return "extension";
    }
    if (/^https?:$/.test(parsed.protocol)) return "website";
    return "browser_internal";
  } catch (e) {
    return "unknown";
  }
}
function tutorialStep(key) {
  try {
    return decodeURIComponent(key || "").trim().toLowerCase().replace(/\s+/g, "_");
  } catch (e) {
    return "unknown";
  }
}
function telemetryId() {
  var _a, _b;
  if ((_a = globalThis.crypto) == null ? void 0 : _a.randomUUID) return globalThis.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  if ((_b = globalThis.crypto) == null ? void 0 : _b.getRandomValues) globalThis.crypto.getRandomValues(bytes);
  else for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
  bytes[6] = bytes[6] & 15 | 64;
  bytes[8] = bytes[8] & 63 | 128;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
function validTelemetryId(value) {
  return typeof value === "string" && /^[a-zA-Z0-9_-]{8,128}$/.test(value);
}
function attributedURL(url, anonId) {
  if (!validTelemetryId(anonId)) return url;
  const parsed = new URL(url);
  parsed.searchParams.set("anonId", anonId);
  return parsed.href;
}
const errorCodes = /* @__PURE__ */ new Set([
  "permission",
  "network",
  "no-mic",
  "no_speech",
  "unsupported",
  "aborted",
  "other",
  "NotAllowedError",
  "SecurityError",
  "NotFoundError",
  "NotReadableError",
  "NotSupportedError",
  "InvalidStateError",
  "missing_email",
  "quota",
  "content_unavailable",
  "execution_failed",
  "auth/popup-closed-by-user",
  "auth/cancelled-popup-request",
  "auth/popup-blocked",
  "auth/network-request-failed",
  "auth/invalid-email",
  "auth/wrong-password",
  "auth/invalid-credential",
  "auth/user-not-found",
  "auth/email-already-in-use",
  "auth/weak-password",
  "auth/too-many-requests",
  "auth/operation-not-allowed",
  "auth/account-exists-with-different-credential",
  "auth/user-disabled",
  "auth/unauthorized-domain"
]);
function telemetryError(error) {
  const e = error;
  const code = typeof error === "string" ? error : (e == null ? void 0 : e.code) || (e == null ? void 0 : e.name) || "other";
  return errorCodes.has(code) ? code : "other";
}
function safeTelemetry(properties = {}) {
  const result = {};
  for (const [key, value] of Object.entries(properties)) {
    if (!fields.has(key)) continue;
    if (key === "url") {
      try {
        const url = new URL(value);
        result.page_kind = pageKind(value);
        result.url = /^https?:$/.test(url.protocol) ? `${url.protocol}//website` : `${url.protocol}//extension`;
      } catch (e) {
      }
    } else if (typeof value === "boolean" || typeof value === "number" && Number.isFinite(value)) {
      result[key] = value;
    } else if (typeof value === "string") {
      result[key] = key === "error_code" ? telemetryError(value) : value.slice(0, 128);
    }
  }
  return result;
}
function emitTelemetry(sink, event, properties = {}) {
  try {
    Promise.resolve(sink == null ? void 0 : sink(event, safeTelemetry(properties))).catch(() => {
    });
  } catch (e) {
  }
}
export {
  TELEMETRY_VERSION,
  TUTORIAL_VERSION,
  attributedURL,
  emitTelemetry,
  pageKind,
  safeTelemetry,
  telemetryError,
  telemetryId,
  tutorialStep,
  validTelemetryId
};
